import { IconWarningRegular, skinVars, Spinner, Stack, Text3, useDialog } from '@telefonica/mistica';
import { AxiosError } from 'axios';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import ManagementErrorAlert, { EErrorAlert } from '../../../components/ManagementErrorAlert';
import { loginCode } from '../../../services/LoginService';
import { setInfoError } from '../../../utils/dataTransformation/errorMesssages';
import { getScopeRole } from '../../../utils/dataTransformation/role';
import { ETypeUser } from '../../../utils/store/model/store.model';
import { getEnv } from '../../../utils/dataTransformation/environments';
import { useGlobalContext } from '../../../context/global-context/GlobalContext';

const LoginCallback: React.FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [params] = useSearchParams();
    const { context, setContext } = useGlobalContext();
    const [loading, setLoading] = useState<boolean>(true);
    const [alertError, setAlertError] = useState<EErrorAlert>();
    const [showAlertError, setShowAlertError] = useState<boolean>(false);
    const code = params.get('code');
    const state = params.get('state');
    const { dialog } = useDialog();
    const savedState = sessionStorage.getItem('login-state');

    useEffect(() => {
        if (state !== savedState) {
            navigate('/login');
        } else {
            const clientId = getEnv('VITE_CLIENT_ID');
            const redirectUri = getEnv('VITE_LOGIN_CALLBACK');

            if (!clientId || !redirectUri) {
                console.warn('Missing callback envs', { clientId, redirectUri });
                navigate('/login');
                return;
            }

            loginCode({
                clientId: clientId,
                code,
                redirectUri: redirectUri,
            })
                .then(() => {
                    getScopeRole()
                        .then((response) => {
                            const islight = response === ETypeUser.LIGHT;
                            window.localStorage.setItem('scope', JSON.stringify(response));
                            if (islight) setContext({ ...context, typeUser: response });
                            navigate('/home');
                        })
                        .catch((error) => {
                            console.error(error);
                        });
                })
                .catch((error: AxiosError) => {
                    console.error(error);
                    setLoading(false);
                    const { id, localizedDescription, title } = setInfoError(error);
                    dialog({
                        asset: <IconWarningRegular color={skinVars.colors.feedbackErrorBackground} size={53} />,
                        title,
                        message: (() => {
                            return (
                                <Stack space={16}>
                                    <Text3 light color={skinVars.colors.textSecondary}>
                                        {localizedDescription}
                                    </Text3>
                                    {id && (
                                        <Text3 light color={skinVars.colors.textSecondary}>
                                            {`${t('codeError')} ${id}`}
                                        </Text3>
                                    )}
                                </Stack>
                            );
                        })() as any,
                        acceptText: t('buttonUnderstoodFeedback'),
                        onAccept: () => navigate('/login'),
                        onCancel: () => navigate('/login'),
                    });
                });
        }
    }, []);

    return (
        <>
            <div style={{ display: loading ? 'fixed' : 'none' }} className='c-spinner'>
                <Spinner size={24} />
                <span className='c-spinner-overlay'></span>
            </div>
            {showAlertError && <ManagementErrorAlert type={alertError} />}
        </>
    );
};

export default LoginCallback;
